module.exports = __webpack_public_path__ + "site/img/30.38dc36d2.jpg";